import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ChatWidget from './components/ChatWidget';
import SupportLogin from './components/SupportLogin';
import SupportDashboard from './components/SupportDashboard';
import WaitingChats from './components/WaitingChats';
import ActiveChats from './components/ActiveChats';
import TranscriptsPage from './components/TranscriptsPage';
import DemoWebsite from './components/DemoWebsite';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00aae5',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }
  
  // Redirect to login only if not authenticated and not loading
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Component to conditionally show ChatWidget
const ConditionalChatWidget = () => {
  const location = useLocation();
  const isCustomerPage = location.pathname === '/demo';
  
  return isCustomerPage ? <ChatWidget /> : null;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/demo" element={<DemoWebsite />} />
              <Route path="/login" element={<SupportLogin />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <SupportDashboard />
                </ProtectedRoute>
              } />
              <Route path="/waiting" element={
                <ProtectedRoute>
                  <WaitingChats />
                </ProtectedRoute>
              } />
              <Route path="/chats" element={
                <ProtectedRoute>
                  <ActiveChats />
                </ProtectedRoute>
              } />
              <Route path="/transcripts" element={
                <ProtectedRoute>
                  <TranscriptsPage />
                </ProtectedRoute>
              } />
              <Route path="/" element={<Navigate to="/dashboard" />} />
            </Routes>
            
            {/* Chat Widget - Only visible on customer-facing pages */}
            <ConditionalChatWidget />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
